import { Box, Skeleton } from '@mui/material';
import { InsightSummaryContainer } from '../Insights/InsightTreeItem';

function InsightSummarySkeleton() {
  return (
    <InsightSummaryContainer>
      <Skeleton variant="text" width="100%" height={20} />
      <Skeleton variant="text" width="100%" height={20} />
      <Skeleton variant="text" width="100%" height={20} />
      <Skeleton variant="text" width="90%" height={20} />
      <Skeleton variant="text" width="85%" height={20} />
    </InsightSummaryContainer>
  );
}

export default InsightSummarySkeleton;
